import Vue from "vue";
import VueToast from "vue-toast-notification";
import App from "./App.vue";
import router from "./router";
import AppStorage from "@/AppStorage";
import "vue-toast-notification/dist/theme-sugar.css";
import BootstrapVue from "bootstrap-vue";

Vue.config.productionTip = false;
Vue.AppStorage = new AppStorage();
Vue.prototype.AppStorage = Vue.AppStorage;
Vue.use(VueToast, { position: "top" });
Vue.use(BootstrapVue);
Vue.$backgroundImage = "background-" + (Math.floor(Math.random() * 7) + 1).toString();
new Vue({
    router,
    render: h => h(App)
}).$mount("#app");
